import axios from '../axios'
import { BADWORDROUTES } from 'src/router/Api'

export const getBadWordCategories = async (params?: any) => {
	return await axios.get(BADWORDROUTES.categories, { params })
}

export const createBadWordCategory = async (payload: {
	name: string
	code?: string
	description?: string | null
	status?: boolean
}) => {
	return await axios.post(BADWORDROUTES.categories, payload)
}

export const updateBadWordCategory = async (id: string, payload: any) => {
	return await axios.put(`${BADWORDROUTES.categories}/${id}`, payload)
}

export const deleteBadWordCategory = async (id: string) => {
	return await axios.delete(`${BADWORDROUTES.categories}/${id}`)
}

export const getBadWords = async (params?: any) => {
	return await axios.get(BADWORDROUTES.words, { params })
}

export const createBadWord = async (payload: {
	category_id: string
	word: string
	match_type?: string
	status?: boolean
}) => {
	return await axios.post(BADWORDROUTES.words, payload)
}

export const updateBadWord = async (id: string, payload: any) => {
	return await axios.put(`${BADWORDROUTES.words}/${id}`, payload)
}

export const deleteBadWord = async (id: string) => {
	return await axios.delete(`${BADWORDROUTES.words}/${id}`)
}

export const getContentModerationCases = async (params?: any) => {
	return await axios.get(BADWORDROUTES.moderationCases, { params })
}

export const approveContentModerationCase = async (
	id: string,
	payload: { note?: string },
) => {
	return await axios.patch(BADWORDROUTES.approveCase(id), payload)
}

export const hideContentModerationCase = async (
	id: string,
	payload: { note?: string },
) => {
	return await axios.patch(BADWORDROUTES.hideCase(id), payload)
}
